module.exports = __webpack_public_path__ + "img/header.64cb6ba4.jpeg";